// Copyright (c) 2022 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Actions from "../actions"
import * as Slice from "../slices/stats"
import { showSnackBar } from "../../snackbar/actions"
import { executor, Init, postExpectationService } from "../../../app/rpc"
import {
  ListMemberExpectationsRequestSchema,
  ListMemberExpectationsResponse,
} from "../../../generated/legebill/site/postexpectation/v4/post_expectation_pb"

type ListMemberExpectationsRpc = (request: Init<typeof ListMemberExpectationsRequestSchema>) => Observable<ListMemberExpectationsResponse>

export const listMemberExpectations = (listMemberExpectationsRpc: ListMemberExpectationsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.listMemberExpectations.match),
      mergeMap(action => listMemberExpectationsRpc(action.payload)
        .pipe(
          map(t => ({
            siteId: action.payload.siteId ?? "",
            memberExpectations: t.memberExpectations,
          })),
          map(Slice.setSiteMemberExpectations),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_list_member_expectations_failed",
              message: "Failed to list time posting goals. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const listMemberExpectationsRpc = (request: Init<typeof ListMemberExpectationsRequestSchema>): Observable<ListMemberExpectationsResponse> =>
  executor(() => postExpectationService.listMemberExpectations(create(ListMemberExpectationsRequestSchema, request)))

export default listMemberExpectations(listMemberExpectationsRpc)
